// src/pages/Comfirmation.js
import React, { useState, useEffect } from 'react';
import customers from './conf/Customers';
import CustomerStyles from './conf/CustomerStyles';
import { showBootboxModal } from './conf/utils';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import Shipment from './conf/Shipment';
import * as global from './conf/global';
import { writeLogMsg } from './conf/log';

function Confirmation() {
    writeLogMsg('Confirmation page');
    const [selectedCustomer, setSelectedCustomer] = useState(customers.shortlist.find(item => item.id.toString() === localStorage.getItem('customer')) || customers.shortlist.find(item => item.label === global.APP_DEFAULT_CUSTOMER) || customers.shortlist[0]);
    CustomerStyles(selectedCustomer);
    const { t } = useTranslation();
    const navigation = useNavigate();
    const location = useLocation();
    const [shipment, setShipment] = useState(new Shipment());
    const [shipmentNumber, setShipmentNumber] = useState('');
        
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    const {state} = location;

    useEffect(() => {
      // Vérifiez si l'état de l'expédition est présent
      if (state && state.shipment) {
          // Chargez l'expédition à partir de l'état
          setShipment(Object.assign(new Shipment(), state.shipment));
          writeLogMsg('Confirmation: Shipment loaded: ', state.shipment);
          setShipmentNumber(state.shipment.ShipmentNumber);
          writeLogMsg('Confirmation: shipmentNumber '+ state.shipment.ShipmentNumber);
      } else {
          writeLogMsg('No shipment found, redirecting to Home');
          navigation("/");
      }
    }, [state, navigation]); // Dépendances pour re-exécuter l'effet si l'état change

    const toggle = () => {
        navigation(-1);
      };

    const collect = () => {
        validate(global.SHIP_TYPE_COL);
    };
        
    const delivery = () => {
        validate(global.SHIP_TYPE_DEL);
    };

    const validate = async (shipmentType) => {
        // Ask web service for shipment infos
        try {
            var shipmentWS;
            var atOptions = {
                method : 'GET',
                //mode : 'no-cors',
                timeout: global.HTTP_TIMEOUT,
                headers: { 'Authorization': 'Basic ' + selectedCustomer.auth },
                cache: 'no-cache',
                params: { 'fixCache': new Date().getTime() }
            };
            // Construct url
            var astrUrl = global.APP_URL + global.WS_SCAN;
            astrUrl = astrUrl.replace("%KEY%", selectedCustomer.code);
            astrUrl = astrUrl.replace("%CAB%", state.shipment.ShipmentNumber);
            astrUrl = astrUrl.replace("%SHIPTYPE%", shipmentType);
            astrUrl = astrUrl.replace("%ID%", selectedCustomer.id);

            const response = await fetch(astrUrl, atOptions);
            writeLogMsg('Confirmation: Response:', response);
            if (!response.ok) {
                // Display Network error
                showBootboxModal(t('MSG_NETWORK_ERROR'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
                return;
            }
            const data = await response.json();
            writeLogMsg('Confirmation: Data:', data);
            // WS success
            if (data.messageError === "" && data.found) {
                writeLogMsg('Confirmation: Shipment found:', data);
                // Create new shipment with info returned by WS
                shipmentWS = new Shipment();
                shipmentWS.ShipmentType = shipmentType;
                shipmentWS.Customer = selectedCustomer;
                shipmentWS.ShipmentNumber = shipmentNumber;

                if (data.szName) shipmentWS.ConsigneeName = data.szName; 
                else shipmentWS.ConsigneeName = "";

                if (data.phone) shipmentWS.PhoneNumber = data.phone; 
                else shipmentWS.PhoneNumber = "";

                if (data.szAddress1) shipmentWS.ConsigneeAddress1 = data.szAddress1; 
                else shipmentWS.ConsigneeAddress1 = "";

                if (data.szAddress2) shipmentWS.ConsigneeAddress2 = data.szAddress2; 
                else shipmentWS.ConsigneeAddress2 = "";

                if (data.szAddress3) shipmentWS.ConsigneeAddress3 = data.szAddress3; 
                else shipmentWS.ConsigneeAddress3 = "";

                if (data.postCode) shipmentWS.ConsigneePostalCode = data.postCode; 
                else shipmentWS.ConsigneePostalCode = "";

                if (data.town) shipmentWS.ConsigneeTown = data.town; 
                else shipmentWS.ConsigneeTown = "";

                shipmentWS.AddressDefined = (shipmentWS.ConsigneeName !== "" || shipmentWS.ConsigneeAddress1 !== "" || shipmentWS.ConsigneeAddress2 !== "" || shipmentWS.ConsigneeAddress3 !== "" || shipmentWS.ConsigneePostalCode !== "" || shipmentWS.ConsigneeTown !== "");
                //writeLogMsg('Confirmation: Shipment created:', shipmentWS);
            } else {
                shipmentWS = new Shipment();
                shipmentWS.Error = data.messageError;
                if (data.messageError === "UNKNOWN_CAB" && selectedCustomer.wsConsult === customers.ws_consult.ConsultOnly) {
                    shipmentWS.ShipmentNumber = shipment.ShipmentNumber;
                }
            }
            writeLogMsg('Confirmation: Shipment after WS call:', shipmentWS);
            // Check if shipment is valid
            if (shipmentWS != null) {
                if (shipmentWS.ShipmentNumber !== undefined && shipmentWS.ShipmentNumber !== "") {
                    //shipment.CabScanned = keyValueScanned;
                } else {
                    if (shipmentWS.Error === "CAB_EVENTEXIST"){
                        // Display Unknown shipment error
                        showBootboxModal(t('MSG_CAB_EVENTEXIST'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
                        return;
                    }
                    else {
                        // Display Unknown shipment error
                        showBootboxModal(t('MSG_CAB_UNKNOWN'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
                        return;
                    }
                } 
            } else {
                if (selectedCustomer.wsConsult === customers.ws_consult.ConsultOnly || selectedCustomer.wsConsult === customers.ws_consult.ConsultAndExistAndNoNetwork) {
                    // WS unreachable -> Start delivery with empty shipment
                    shipmentWS = new Shipment();
                    shipmentWS.ShipmentType = shipmentType;
                    shipmentWS.Customer = selectedCustomer;
                    shipmentWS.ShipmentNumber = shipmentNumber;
                } else {
                    // Display Network error
                    showBootboxModal(t('MSG_NETWORK_ERROR'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
                    return;
                }
            }
            // Go to next screen
            navigation('/Delivery', { state: { shipment: shipmentWS } });
        } catch (error) {
            console.error('Error:', error);
            showBootboxModal(t('MSG_NETWORK_ERROR'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
        }
    };

  useEffect(() => {
    const handleOnline = async () => {
      setIsOnline(true);
      writeLogMsg('Confirmation: handleOnline: Vous êtes en ligne !');

      if (navigator.serviceWorker && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ type: 'P4C_SYNC_ONLINE' });
        writeLogMsg('Confirmation: handleOnline: Envoi du message de synchronisation au service worker');
      } else {
        writeLogMsg('Confirmation: handleOnline: Service worker non disponible ou pas contrôleur actif');
      }

    };

    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  useEffect(() => {
      const handle = () => navigation("/");

      window.addEventListener("app-back", handle);
      return () => window.removeEventListener("app-back", handle);
  }, [navigation]);

    return (
        <div id="mainDiv" style={{position : 'static'}} >
            <div>
                {/* Navigation bar */}
                <nav className="navbar navbar-expand-lg navbar-fixed-top navbar-default col-sm-12" role="navigation" style={{ display: 'flow-root' }}>
                    <div className="menu-icon menu-icon-arrow float-left is-opened" onClick={toggle}>
                        <span />
                    </div>
                </nav>

                {/* Ask for Delivery or Collect ? */}
                <div className="col-sm-10 col-lg-8 mx-auto">
                    {/* Customer logo */}
                    <div className="form-group">
                        {selectedCustomer && selectedCustomer.name && (
                        <img
                            src={`assets/images/xhdpi/logo-${selectedCustomer.name}.png`}
                            srcSet={`assets/images/mdpi/logo-${selectedCustomer.name}.png 320w,
                                    assets/images/hdpi/logo-${selectedCustomer.name}.png 480w,
                                    assets/images/xhdpi/logo-${selectedCustomer.name}.png 640w,
                                    assets/images/xxhdpi/logo-${selectedCustomer.name}.png 960w`}
                            alt={`Logo ${selectedCustomer.name}`}
                            className="img-responsive logo_center_img"
                        />
                        )}
                    </div>        
                    {/* Collect button */}
                    <div className="text-center">
                        <button id="btnCollect" onClick={collect} className="btn btn-default btn_chooseShipment">
                            <img src="assets/images/picto/picto-enlevement.png" className="image-responsive picto" alt="Collect" /><br/>
                            <span>{t('BTN_COLLECT')}</span>
                        </button>
                    </div>
                    {/* Delivery button */}
                    <div className="text-center">
                        <button id="btnDelivery" onClick={delivery} className="btn btn-default btn_chooseShipment">
                            <img src="assets/images/picto/picto-livraison.png" className="image-responsive picto" alt="Delivery"/><br/>
                            <span>{t('BTN_DELIVERY')}</span>
                        </button>
                    </div>

                    {/* Parcel img */}
                    <div className="form-group">
                        <img src="assets/images/visuel-menu.png" className="img-responsive logo_center_img" alt="Parcel" />
                    </div> 
                </div>
            </div>
        </div>
    );
}
export default Confirmation;